import { createSlice } from "@reduxjs/toolkit";
import { clusterInitialState } from "@/components/PageCluster/redux/initialState";
import clusterReducer from "@/components/PageCluster/redux/reducers";

const clusterSlice = createSlice({
  name: "cluster",
  initialState: clusterInitialState,
  reducers: clusterReducer,
});

export const { setLoading, setError, setClusterData, setDevice, setClusterSlug } = clusterSlice.actions;

export default clusterSlice.reducer;
